import { useQuery } from '@tanstack/react-query';

import { catalogQueries } from '@/lib/queries/catalog';

/**
 * Category selector for the creator video flows. Nullable by design —
 * uncategorized videos simply don't appear in browse category rows. While the
 * schema is gated (PLAN §4) the visibleCategories query stubs to [], so this
 * renders its empty state; it lights up automatically once categories exist.
 */
export function CategoryPicker({
  value,
  onChange,
}: {
  value: string | null;
  onChange: (categoryId: string | null) => void;
}) {
  const { data: categories = [] } = useQuery(catalogQueries.visibleCategories());

  return (
    <div>
      <p className="mb-1 font-sans text-xs uppercase tracking-[0.12em] text-ink/60">Category</p>
      {categories.length === 0 ? (
        <p className="font-sans text-xs text-ink/40">
          No categories yet — an admin adds these under Admin · Categories.
        </p>
      ) : (
        <div className="flex flex-wrap gap-1.5">
          <button
            type="button"
            onClick={() => onChange(null)}
            className={`rounded-sm border px-2 py-1 text-xs ${
              value === null
                ? 'border-oxblood bg-oxblood/10 text-oxblood'
                : 'border-ink/15 text-ink/70 hover:border-oxblood'
            }`}
          >
            None
          </button>
          {categories.map((c) => {
            const active = value === c.id;
            return (
              <button
                key={c.id}
                type="button"
                onClick={() => onChange(c.id)}
                className={`rounded-sm border px-2 py-1 text-xs ${
                  active
                    ? 'border-oxblood bg-oxblood/10 text-oxblood'
                    : 'border-ink/15 text-ink/70 hover:border-oxblood'
                }`}
              >
                {c.name}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
